import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inputBlock" }
const _hoisted_2 = ["id", "inputmode", "maxlength", "type", "name", "autocomplete", "placeholder"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorAlert = _resolveComponent("ErrorAlert")!
  const _component_InfoAlert = _resolveComponent("InfoAlert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
      inputmode: _ctx.inputMode,
      maxlength: _ctx.maxlength,
      type: _ctx.type,
      name: _ctx.name,
      autocomplete: _ctx.autocomplete,
      class: _normalizeClass(_ctx.inputClass),
      style: _normalizeStyle({
        padding: _ctx.currentValue ? '25px 16px 9px' : '0 16px',
      }),
      placeholder: _ctx.label,
      onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeypress && _ctx.onKeypress(...args))),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 46, _hoisted_2), [
      [_vModelDynamic, _ctx.currentValue]
    ]),
    (_ctx.currentValue.length > 0)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: _normalizeClass(_ctx.labelClass)
        }, _toDisplayString(_ctx.label), 11, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.id === 'pin')
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
          (_ctx.errorMessage)
            ? (_openBlock(), _createBlock(_component_ErrorAlert, {
                key: 0,
                message: _ctx.errorMessage
              }, null, 8, ["message"]))
            : (_openBlock(), _createBlock(_component_InfoAlert, {
                key: 1,
                message: _ctx.$t('phoneNumberForm.pinInfoDesc')
              }, null, 8, ["message"]))
        ]))
      : (_ctx.id === 'card-number')
        ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createBlock(_component_ErrorAlert, {
                  key: 0,
                  message: _ctx.errorMessage
                }, null, 8, ["message"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("small", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1)
          ]))
  ]))
}